import http from "@/utils/http";


export const BmsAttendanceRecordApi = {
    queryBmsAttendanceDashboardRespVOList(query){
        return http.get(`/server/bmsAttendanceRecord/queryBmsAttendanceDashboardRespVOList`,query);
    }

}